import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { reactive } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
export default {
  __name: 'UpgradeDialog',
  props: {
    title: {
      type: String,
      default: 'Confirm'
    },
    message: {
      type: String,
      default: 'Are you sure?'
    },
    toggleText: {
      type: String,
      default: 'Cancel'
    },
    confirmText: {
      type: String,
      default: 'OK'
    }
  },
  emits: ['confirm', 'cancel'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const state = reactive({
      isVisible: false
    });
    let resolvePromise;
    function open() {
      state.isVisible = true;
      return new Promise(resolve => {
        resolvePromise = resolve;
      });
    }
    function confirm() {
      emits('confirm');
      state.isVisible = false;
      resolvePromise(true);
    }
    function cancel() {
      emits('cancel');
      state.isVisible = false;
      resolvePromise(false);
    }

    // Expose the `open` function to make it accessible from the parent
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_spacer = _resolveComponent("v-spacer");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createBlock(_component_v_dialog, {
        modelValue: state.isVisible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => state.isVisible = $event),
        "max-width": "500",
        "data-cy": "ll-confirmation-dialog"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card, null, {
          default: _withCtx(() => [_createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.title), 1)]),
            _: 1
          }), _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [_renderSlot(_ctx.$slots, "message", {}, () => [_createTextVNode(_toDisplayString(__props.message), 1)])]),
            _: 3
          }), _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [_createVNode(_component_v_spacer), _createVNode(LlSecondaryButton, {
              variant: "outlined",
              onClick: cancel
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.toggleText), 1)]),
              _: 1
            }), _createVNode(LlSecondaryButton, {
              variant: "flat",
              color: "primary",
              onClick: confirm,
              "data-cy": "confirm-button"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.confirmText), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 3
        })]),
        _: 3
      }, 8, ["modelValue"]);
    };
  }
};